/**
 * Finds maximum width and height that fits inside given bounds
 */
const getMaxInsideBounds = ({
	width,
	height,
	aspectRatio,
}: {
	width: number;
	height: number;
	aspectRatio: number;
}) => {
	const maxWidth = Math.min(width, height * aspectRatio);
	const maxHeight = Math.min(height, width / aspectRatio);
	const maxInsideBounds = {
		width: maxWidth,
		height: maxHeight,
	};
	return maxInsideBounds;
};
export default getMaxInsideBounds;
